export default "/images/vendor/flag-icon-css/flags/1x1/il.svg?3bc4ce048568d30c327fe163783c8f63";